export default function ServiceAreasSection() {
  return (
    <section className="py-16 md:py-24 px-4 md:px-8 lg:px-12 bg-primary-500">
      <div className="max-w-5xl mx-auto text-center">
        <h2 className="font-heading text-3xl md:text-4xl font-medium text-background-50 mb-4">
          Proudly Serving Southern California
        </h2>
        <p className="text-background-200/90 mb-10 max-w-xl mx-auto">
          Based in Corona, we provide professional painting services across five counties.
        </p>
        <div className="flex flex-wrap justify-center gap-3 md:gap-4">
          {[
            "Riverside County",
            "San Bernardino County",
            "Orange County",
            "San Diego County",
            "Los Angeles County",
          ].map((area) => (
            <span
              key={area}
              className="bg-background-50/10 backdrop-blur-sm text-background-50 border border-background-50/20 px-5 py-2.5 rounded-full text-sm font-medium whitespace-nowrap"
            >
              {area}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}